import Section5 from './Section5'
export default Section5;